import { GlobalConfigState } from '@/interfaces/config';
import { APIClientConfig } from '~/interfaces/APIClient';

export function getAxiosConfig(state: GlobalConfigState): APIClientConfig {
  return {
    API_BASE_PATH: state.API_BASE_PATH,
    BASE_URL: state.BASE_URL,
  };
}

export function getHeaderLogo(state: GlobalConfigState): string {
  return state.BRANDING_CONFIG?.header_logo_url;
}

export function getFooterLogo(state: GlobalConfigState): string {
  return state.BRANDING_CONFIG?.footer_logo_url ?? '';
}

export function getFooterAddress(state: GlobalConfigState): string {
  return state.BRANDING_CONFIG?.footer_object.footer_address ?? '';
}

export function getLegalBusinessName(state: GlobalConfigState): string {
  return state.BRANDING_CONFIG?.footer_object.legal_business_name ?? '';
}

export function getBrandSupportEmail(state: GlobalConfigState): string {
  return state.BRANDING_CONFIG?.footer_object.support_email ?? '';
}

export function getBrandSupportPhone(state: GlobalConfigState): string {
  return state.BRANDING_CONFIG?.footer_object.support_number ?? '';
}

export function getBrandName(state: GlobalConfigState): string {
  return state.BRANDING_CONFIG?.brand_name ?? '';
}

export function isConfigLoaded(state: GlobalConfigState): boolean {
  return !!Object.keys(state).length
    && !!state.BRANDING_CONFIG
    && !!Object.keys(state.BRANDING_CONFIG);
}
